import { Label } from "@comps/ui/label";
import { TW_FieldFormulaSection, TW_FieldFormulaSectionLabelGrow, TW_FieldFormulaSectionTitle } from "@utils/twClasses";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormulaEditor } from "./FormulaEditor";
import { useModelStore } from "src/store";

export interface FieldFormulaSectionProps {
    formula: string | undefined;
    onFormulaChange: (formula: string) => void;
    currentFieldKey?: string;
}
export function FieldFormulaSection({ formula, onFormulaChange, currentFieldKey }: FieldFormulaSectionProps) {
    const { t } = useTranslation();
    const selectedObjectInfos = useModelStore(store => store.selectedObjectInfos)
    const [hasFormula, setHasFormula] = useState(formula !== undefined && formula !== "");

    const handleToggleFormula = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        setHasFormula(!hasFormula);
    };

    return (
        <div className={TW_FieldFormulaSection}>
            <div className={TW_FieldFormulaSectionTitle} onClick={handleToggleFormula}>
                <Label className={TW_FieldFormulaSectionLabelGrow}>{t("field.formula.label")}</Label>
                {hasFormula ? (
                    <ChevronDown className="h-4 w-4" />
                ) : (
                    <ChevronRight className="h-4 w-4" />
                )}
            </div>
            {hasFormula && (
                <FormulaEditor
                    objectKey={selectedObjectInfos?.object._key}
                    formula={formula}
                    onFormulaChange={onFormulaChange}
                    currentFieldKey={currentFieldKey}
                    fieldSelectorEnabled={true}
                />
            )}
        </div>
    )
}
